import { removeTokens } from './auth'

// Use Vite env variable or fallback to default
// In production, use relative path (same server), in development use localhost:8080
const API_BASE = import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.PROD ? '' : 'http://localhost:8080')

// Sessions are cookie-only. Drop tokens that older versions left in localStorage.
removeTokens()

// Shared refresh promise: ensures only one /api/refresh call runs at a time.
// All concurrent 401 handlers wait for the same promise instead of each firing
// their own request, which would exhaust the auth rate limit (5/min) and, with
// refresh token rotation, invalidate the session.
let refreshPromise = null

function notifySessionExpired() {
  removeTokens()
  globalThis.dispatchEvent(new CustomEvent('auth:session-expired'))
}

async function doRefresh() {
  const refreshRes = await fetch(API_BASE + '/api/refresh', {
    method: 'POST',
    credentials: 'include',
  })

  if (!refreshRes.ok) {
    notifySessionExpired()
    return false
  }

  return true
}

async function refreshWithCookie(url, options, headers) {
  if (!refreshPromise) {
    refreshPromise = doRefresh().finally(() => {
      refreshPromise = null
    })
  }

  const ok = await refreshPromise
  if (!ok) return null

  // server updated the access_token and refresh_token cookies
  return await fetch(url, { ...options, headers, credentials: 'include' })
}

export async function apiFetch(path, options = {}) {
  const url = path.startsWith('http') ? path : API_BASE + path

  // Don't set Content-Type for FormData - browser will set it automatically with boundary
  const headers = options.body instanceof FormData
    ? { ...options.headers }
    : { 'Content-Type': 'application/json', ...options.headers }

  const response = await fetch(url, { ...options, headers, credentials: 'include' })

  if (response.status === 401) {
    const refreshedResponse = await refreshWithCookie(url, options, headers)
    return refreshedResponse || response
  }

  return response
}
